import { isLiveMode } from "../common/methods";

export const baseServerAdress = isLiveMode()
  ? {
      API: ``,

      baseURL: `http://promoerp.tekweld.com/`,
      schemaName: "TEKW1122",
    }
  : {
      API: ``,
      baseURL: `http://promoerptest.tekweld.com/`,
      schemaName: "TEKWTEST",
    };
